import React, { ComponentType, LazyExoticComponent } from "react";
import {
  CODE_SPLITTING_REFRESH_QUERY_PARAM,
  PAGE_SPINNER_MARGIN_FROM_TOP,
} from "common/constants.ts";
import LoadingSpinnerOverlay from "common/Overlays/LoadingSpinnerOverlay.tsx";
import * as Sentry from "@sentry/react";
import QueriesError from "common/Empty/QueriesError.tsx";

export const lazyLoad = <T extends ComponentType<any>>(
  importer: () => Promise<{ default: T }>
): LazyExoticComponent<T> => {
  const retryImport = async () => {
    try {
      return await importer();
    } catch (error) {
      for (let i = 0; i < 4; i++) {
        await new Promise((resolve) => setTimeout(resolve, 300));
        try {
          return await importer();
        } catch {}
      }
      const url = new URL(window.location.href);
      if (!url.searchParams.get(CODE_SPLITTING_REFRESH_QUERY_PARAM)) {
        url.searchParams.append(CODE_SPLITTING_REFRESH_QUERY_PARAM, "1");
        window.location.replace(url.toString());
        return {
          default: () => (
            <LoadingSpinnerOverlay
              isLoading={true}
              spinnerMarginTop={PAGE_SPINNER_MARGIN_FROM_TOP}
              spinnerSize="large"
            />
          ),
        };
      } else {
        Sentry.captureException(
          "Failed to load code splitting file, showing error page."
        );
        return {
          default: (() => <QueriesError isGeneralPageError={true} />) as any,
        };
      }
    }
  };
  return React.lazy(retryImport);
};
